import { useLang } from "@/context/LanguageContext";

export const Marquee = () => {
  const { t } = useLang();
  const items = t.marquee;
  return (
    <div className="relative border-y border-white/[0.06] bg-[#0a0a0a]/70 backdrop-blur-sm py-5 overflow-hidden" data-testid="marquee">
      <div className="marquee">
        {[0, 1].map((k) => (
          <div key={k} className="marquee-track" aria-hidden={k === 1}>
            {items.map((item, i) => (
              <div key={i} className="flex items-center gap-10 px-10 whitespace-nowrap">
                <span className="font-display font-semibold text-lg sm:text-xl tracking-wide text-[#8a8a8a]">{item}</span>
                <span className="w-1.5 h-1.5 rounded-full bg-[#00f2fe] shadow-[0_0_10px_rgba(0,242,254,0.8)]" />
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
